import { useEffect, useState } from "react";

const BERLIN_TIME_ZONE = "Europe/Berlin";

export const MONTHLY_ACTION_VARIANTS = [
  { id: "wakeup", label: "10 Wake-Up-Massagen", personCount: 10 },
  { id: "classic", label: "3 Classic-Massagen", personCount: 3 },
  { id: "intense", label: "1 Intense-Massage", personCount: 1 },
];

export const getMonthlyAction = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: BERLIN_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
  }).formatToParts(date);
  const year = parts.find((part) => part.type === "year")?.value;
  const month = parts.find((part) => part.type === "month")?.value;
  const monthName = new Intl.DateTimeFormat("de-DE", {
    timeZone: BERLIN_TIME_ZONE,
    month: "long",
  }).format(date);
  return {
    period: `${year}-${month}`,
    label: `${monthName.toLocaleUpperCase("de-DE")} AKTION`,
  };
};

export const useMonthlyAction = () => {
  const [action, setAction] = useState(getMonthlyAction);
  useEffect(() => {
    const refreshMonth = () => setAction((current) => {
      const next = getMonthlyAction();
      return next.period === current.period ? current : next;
    });
    const timer = window.setInterval(refreshMonth, 60 * 1000);
    document.addEventListener("visibilitychange", refreshMonth);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", refreshMonth);
    };
  }, []);
  return action;
};
